export const VOUCHER = 'VOUCHER'